import { useLayoutEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@core/hooks/useAuth';

export default function ProtectedRoute({ redirectTo = '/', children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      window.dispatchEvent(
        new CustomEvent('open-auth-modal', {
          detail: { mode: 'login', redirect: location.pathname + location.search },
        }),
      );
    }
  }, [isAuthenticated, location]);

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }
  return children;
}
